import React from 'react'
import Layout from '../../components/shared/Layout/Layout'
import {  useSelector } from 'react-redux'

const AdminHome = () => {
    const {user} = useSelector ((state)=>state.auth);
  return (
    <Layout>
      <div className='container'>
        <div className='d-flex flex-column mt-4'>
            <h1>Welcome Admin <i className='text-success bg-light'>{user?.name}</i></h1>
            <h3>Manage Blood Bank App</h3>
            <hr/>
            <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.

            </p>
        </div>
      </div>
    </Layout>
  )
}

export default AdminHome
